/* eslint-disable no-magic-numbers */
import { CircleLayerSpecification } from 'mapbox-gl';

import { SymbolLayerWithMapIcon } from '../../components/MapIcon';
import {
  CATCH_POSITIONS_ICON_SIZE,
  CATCH_POSITIONS_MINZOOM,
  CATCH_POSITIONS_SIMPLIFIED_CIRCLE_RADIUS,
  CATCH_POSITIONS_SIMPLIFIED_MINZOOM,
  SELECTED_CATCH_POSITION_HIGHLIGHT_SIZE,
} from '../../constants/mapLayers/catchPositions';
import { LayerWithToggleableGroup } from '../../types/types';
import { SOURCE } from '../sources';

export const CATCH_POSITIONS_SIMPLIFIED_LAYER: LayerWithToggleableGroup & CircleLayerSpecification =
  {
    id: 'catch_positions_simplified_layer',
    type: 'circle',
    source: SOURCE.catchPositions.name,
    'source-layer': 'catches',
    minzoom: CATCH_POSITIONS_SIMPLIFIED_MINZOOM,
    paint: {
      'circle-color': '#00C795',
      'circle-radius': CATCH_POSITIONS_SIMPLIFIED_CIRCLE_RADIUS,
      'circle-stroke-width': 0,
      'circle-opacity': ['step', ['zoom'], 0, 7, 0.1, 8, 0.3, 9, 0.5, 10, 0.7, 12, 0.9],
    },
    toggleableGroups: null,
  };

export const CATCH_POSITIONS_LAYER: LayerWithToggleableGroup & SymbolLayerWithMapIcon = {
  id: 'catch_positions_layer',
  type: 'symbol',
  source: SOURCE.catchPositions.name,
  'source-layer': 'catches',
  minzoom: CATCH_POSITIONS_MINZOOM,
  layout: {
    visibility: 'visible',
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-image': 'catch_marker',
    'icon-size': CATCH_POSITIONS_ICON_SIZE,
  },
  toggleableGroups: null,
};

export const CATCH_POSITIONS_HIGHLIGHT_LAYER: LayerWithToggleableGroup & SymbolLayerWithMapIcon = {
  id: 'catch_positions_highlight_layer',
  type: 'symbol',
  source: SOURCE.catchPositions.name,
  'source-layer': 'catches',
  minzoom: CATCH_POSITIONS_MINZOOM,
  layout: {
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-image': 'catch_select',
    'icon-offset': [0, 12],
    'icon-size': SELECTED_CATCH_POSITION_HIGHLIGHT_SIZE,
  },
  filter: ['==', 'external_id', ''],
  toggleableGroups: null,
};

export const CATCH_POSITIONS_SIMPLIFIED_HIGHLIGHT_LAYER: LayerWithToggleableGroup &
  SymbolLayerWithMapIcon = {
  id: 'catch_positions_simplified_highlight_layer',
  type: 'symbol',
  source: SOURCE.catchPositions.name,
  'source-layer': 'catches',
  minzoom: CATCH_POSITIONS_SIMPLIFIED_MINZOOM,
  maxzoom: CATCH_POSITIONS_MINZOOM,
  layout: {
    visibility: 'visible',
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-image': 'highlight',
    'icon-size': ['step', ['zoom'], 0.7, 8, 0.7, 9, 0.7, 11, 0.8],
  },
  filter: ['==', 'external_id', ''],
  toggleableGroups: null,
};
